import React from 'react';
import {injectIntl} from "react-intl";
import CarDeliveryPlanning from "./CarDeliveryPlanning";

class CarDelivery extends React.Component {

  render() {
    const {intl: {formatMessage}} = this.props;
    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'section.car-delivery.title'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <CarDeliveryPlanning />
        </div>
      </div>
    )
  }
}

export default injectIntl(CarDelivery);
